import { useIntl } from 'react-intl';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { i18n as studyI18n } from '@/entities/study';

type UseReportTimelineMetaArgs = {
  date: number | undefined;
  relevantStudy: Study | null | undefined;
  showSource?: boolean;
};

export const useReportTimelineMeta = (
  args: UseReportTimelineMetaArgs,
): string | undefined => {
  const { date, relevantStudy, showSource } = args;
  const { formatDate, formatMessage } = useIntl();

  // The scan time is what the doctor relates to; the record creation time is
  // only the upload moment.
  const studyDate =
    relevantStudy?.Time?.toDate() ?? relevantStudy?.Created?.At?.toDate();
  const reportDate = date ? new Date(date) : undefined;
  const isSameDay =
    studyDate && reportDate
      ? studyDate.toDateString() === reportDate.toDateString()
      : false;

  const sourceMeta =
    showSource && relevantStudy && studyDate
      ? isSameDay
        ? formatMessage(
            {
              id: 'patientProfile.timeline.sourceStudy',
              defaultMessage: 'From {study}',
            },
            { study: formatMessage(studyI18n.studyTypes[relevantStudy.Type]) },
          )
        : formatMessage(
            {
              id: 'patientProfile.timeline.source',
              defaultMessage: 'From {study} · {date}',
            },
            {
              study: formatMessage(studyI18n.studyTypes[relevantStudy.Type]),
              date: formatDate(studyDate, { dateStyle: 'medium' }),
            },
          )
      : undefined;

  const meta = [
    reportDate ? formatDate(reportDate, { dateStyle: 'medium' }) : null,
    sourceMeta,
  ]
    .filter(Boolean)
    .join(' · ');

  return meta || undefined;
};
